import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import { analyticsMiddleware } from "vue-analytics";

import modules from "./modules";

const vuexLocalStorage = new VuexPersist({
  key: "ps_",
  storage: window.localStorage,
});

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules,
  plugins: [vuexLocalStorage.plugin, analyticsMiddleware],
});

export default store;
